/**
 * Gets the container element for rendering the toast
 */
export const getToastContainer = (groupId?: string): Element => {
    if (groupId) {
        // Try to find the specific modal/parent element
        const parentElement = document.querySelector(`.${groupId}`);
        if (parentElement) {
            return parentElement;
        }
    }

    // Fall back to body for default toasts
    return document.body;
};
